import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteComment } from "../services/postServices";
import { FEED_QUERY_KEYS } from "../queryKeys";

interface UseDeleteCommentMutationProps {
  commentId: number;
  postId: number;
}

export const useDeleteCommentMutation = ({ commentId, postId }: UseDeleteCommentMutationProps) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => deleteComment(commentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.comments(postId) });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.commentData(commentId) });
    },
  });

  return {
    deleteComment: mutation.mutate,
    isDeleting: mutation.isPending,
  };
};
